import React, { useRef } from "react";

import "./progress.css";

export default function Progress() {
  let progress = useRef(null);

  window.addEventListener("scroll", () => {
    progress.current.style.width =
      (window.scrollY / window.innerHeight) * 100 + "vw";
  });

  function gotoTop() {
    window.scrollTo(0, 0);
  }

  return (
    <div className="progress-bar__total" ref={progress} onClick={gotoTop}></div>
  );
}
